import {
  encodeTableRefrencing,
  findMatchingNameRange,
  getRangesFromAString,
  bothRangeInSameRow,
  intersectRanges,
  isCellWithinRange,
  convertToAbsolute,
  generateCombinations,
  unifyRanges,
  updateRange,
  needsDecoding,
  decodeTableRefrencing,
  checkIfAbsolute,
  removePartUntilSymbol,
  extractNamedRanges,
  replaceAroundCursor,
  extractWords,
  findWordOccurrenceAtIndex,
  getRefrenceAroundCursor,
} from "../../utils/util";

import { rangeLabelToIndex, rangeIndexToLabel } from "../../components/process-design/cell/Utils";

export class TableHelper {
  constructor(hfInstance, rootState, rootGetters) {
    this.hfInstance = hfInstance;
    this.rootState = rootState;
    this.rootGetters = rootGetters;
  }
  convertToRefrenceFormat({
    text,
    cellId,
    range = "",
    nameRange = "",
    absoluteNameRanges = [],
    cursorPosition = 0,
    tables = [],
  }) {
    const sheetId = this.rootState.sheets.currentSheet.id;
    const namedExpressions = this.rootState.table.namedExpressions.filter(
      (expression) => expression.sheetId === sheetId
    );
    const tempNameRange = findMatchingNameRange(namedExpressions, range);
    const newNameRange = this.rootGetters["table/getLocalNameRangeByDefault"](tempNameRange);
    nameRange = this.rootGetters["table/getLocalNameRangeByDefault"](nameRange);
    if (newNameRange) {
      if (nameRange && newNameRange !== nameRange) {
        text = replaceAroundCursor(
          text,
          cursorPosition,
          encodeTableRefrencing(nameRange, absoluteNameRanges),
          newNameRange
        ).newText;
      } else {
        text = replaceAroundCursor(text, cursorPosition, range, newNameRange).newText;
      }
      text = encodeTableRefrencing(text, absoluteNameRanges);
      nameRange = newNameRange;
    } else if (!newNameRange && nameRange && range) {
      text = replaceAroundCursor(
        text,
        cursorPosition,
        encodeTableRefrencing(nameRange, absoluteNameRanges),
        range
      ).newText;
      nameRange = "";
    } else if (this.rootState.cells.current.design.cellsMetaData[cellId]?.formula) {
      let nameRangeList = [];
      (text + "").replace(/(\w+)((?:\.\.?\w+)+)/g, (match, table, fields) => {
        nameRangeList.push(match);
      });
      const wordsArray = extractWords(text);
      const matches = wordsArray.filter((word) => tables.includes(word));

      nameRangeList.push(...matches);
      nameRangeList.forEach((nameRange) => {
        const tempMatch = this.rootGetters["table/getLocalNameRangeByDefault"](nameRange);
        text = (text + "").replace(nameRange, tempMatch);
      });
      let convertedList = [];
      absoluteNameRanges.forEach((nameRange, index) => {
        const converted = this.rootGetters["table/getLocalNameRangeByDefault"](nameRange.reference);
        convertedList.push({ reference: converted, index: nameRange.index });
      });
      text = encodeTableRefrencing(text, convertedList);
      nameRange = "";
    } else {
      nameRange = "";
    }
    const referenceCounts = {}; // Track occurrences of each range
    // search for range and convert to [@Column] format or header format
    const inRowRanges = text ? getRangesFromAString(text) : null;
    if (inRowRanges) {
      const cellRange = this.rootGetters["cells/getRangeByCellId"](cellId);
      for (let index = 0; index < inRowRanges.length; index++) {
        const range = inRowRanges[index];
        const indexRange = rangeLabelToIndex(range);
        const table = this.rootGetters["table/tableByRangeInSheet"](indexRange);
        // header and total range
        if (table) {
          const totalRange = this.rootGetters["table/totalRowRange"](table);
          const headerRange = this.rootGetters["table/headerRange"](table);

          if (
            indexRange[1] == indexRange[3] &&
            (isCellWithinRange(indexRange, headerRange) || isCellWithinRange(indexRange, totalRange))
          ) {
            const nameRange = this.rootGetters["table/headerRangeIntersectionWithRange"]({
              tableName: this.rootGetters["table/getDefaultNameRangeByLocal"](table.tableName.toLowerCase()),
              range: indexRange,
            });
            let tempText = this.rootGetters["table/getLocalNameRangeByDefault"](nameRange.name);

            const index = tempText.indexOf(".");
            const headerText = isCellWithinRange(indexRange, headerRange) ? ".header." : ".total.";

            if (index !== -1) {
              tempText = tempText.slice(0, index + 1) + headerText + tempText.slice(index + 1);
            }
            const absolute = [];
            referenceCounts[tempText] = (referenceCounts[tempText] || 0) + 1;
            if (checkIfAbsolute(range).column) {
              absolute.push({
                reference: tempText,
                index: 0, // Set index as the count minus 1
              });
            }
            tempText = encodeTableRefrencing(tempText, absolute);
            text = replaceAroundCursor(text, cursorPosition, range, tempText).newText;
          } else {
            if (!bothRangeInSameRow(indexRange, cellRange)) {
              continue;
            }
            const nameRange = this.rootGetters["table/namedRangeIntersectionWithRange"]({
              tableName: this.rootGetters["table/getDefaultNameRangeByLocal"](table.tableName.toLowerCase()),
              range: indexRange,
            });

            if (nameRange) {
              const name = this.rootGetters["table/getLocalNameRangeByDefault"](nameRange.name);
              referenceCounts[name] = (referenceCounts[name] || 0) + 1;
              const absolute = [];
              if (checkIfAbsolute(range).column) {
                absolute.push({
                  reference: name,
                  index: 0, // Set index as the count minus 1
                });
              }
              let tempText = encodeTableRefrencing(name, absolute);
              const index = tempText.indexOf("[");
              if (index !== -1) {
                tempText = tempText.slice(0, index + 1) + "@" + tempText.slice(index + 1);
              }
              text = text.replace(range, tempText);
            }
          }
        }
      }
    }
    return { nameRange, text };
  }
  // input should be in user defined type
  static inRowNameRangeFunction(nameRange, cellId, rootGetters, rootState, absolute = false) {
    let cellRange = rootGetters["cells/getRangeByCellId"](cellId);
    let headerRange = null;
    let totalRange = null;
    if (nameRange.includes("..header")) {
      headerRange = true;
    } else if (nameRange.includes("..total")) {
      totalRange = true;
    }

    nameRange = rootGetters["table/getDefaultNameRangeByLocal"](
      nameRange.replace("..header", "").replace("..total", "")
    );

    let nameRangeValue = rootGetters["table/namedRangeToIndex"](nameRange);
    if (!cellRange || !nameRangeValue) {
      return "";
    }

    if (totalRange || headerRange) {
      const table = rootGetters["table/tableByRangeInSheet"](nameRangeValue);
      if (totalRange) {
        cellRange = rootGetters["table/totalRowRange"](table);
      } else {
        cellRange = rootGetters["table/headerRange"](table);
      }
    }

    nameRangeValue = [nameRangeValue[0], nameRangeValue[1] - 2, nameRangeValue[2], nameRangeValue[3]];

    // Convert to complete row
    cellRange = [0, cellRange[1], rootState.cells.current.design.columns.length - 1, cellRange[3]];

    const intersectionRange = intersectRanges(cellRange, nameRangeValue);
    const rangeLabel = rangeIndexToLabel(intersectionRange);
    const absoluteRange = convertToAbsolute(rangeLabel, { row: true, col: absolute === true });
    const finalRange = headerRange || totalRange ? absoluteRange : convertToAbsolute(rangeLabel, { col: absolute });
    return finalRange;
  }

  generateNamedExpressionsForTable(table, headerList = null) {
    if (!headerList) headerList = table.headerList;

    // Define named ranges
    const headerRange = rangeIndexToLabel(this.rootGetters["table/headerRange"](table));
    const dataRange = rangeIndexToLabel(this.rootGetters["table/dataRange"](table));
    const totalRange = rangeIndexToLabel(this.rootGetters["table/totalRowRange"](table));
    const rangeIds = this.rootGetters["cells/rangeIds"](this.rootGetters["table/headerRange"](table));
    const columnRanges = {};

    const tableName = table.tableName.toLowerCase();
    // Array to hold all named expressions
    const namedExpressions = [];

    // Add the main table range
    namedExpressions.push({
      name: `${tableName}`,
      expression: `${convertToAbsolute(table.tableRange)}`,
    });

    // Add the header, data, and total ranges
    namedExpressions.push({
      name: `${tableName}..header`,
      expression: `${convertToAbsolute(headerRange)}`,
    });

    namedExpressions.push({
      name: `${tableName}..data`,
      expression: `${convertToAbsolute(dataRange)}`,
    });

    namedExpressions.push({
      name: `${tableName}..total`,
      expression: `${convertToAbsolute(totalRange)}`,
    });

    // Add named expressions for each column header
    headerList.forEach((header, index) => {
      header = String(header).toLocaleLowerCase();
      const columnRange = this.rootGetters["table/columnRangeExcludeHeader"](rangeIds[index], table);
      columnRanges[header] = columnRange;
      namedExpressions.push({
        name: `${tableName}.${header}`,
        expression: `${convertToAbsolute(rangeIndexToLabel(columnRange))}`,
      });
    });

    // Generate combinations of headers and add named expressions for combined ranges
    const combinations = generateCombinations(headerList);
    combinations.forEach(([header1, header2]) => {
      const range1 = columnRanges[header1];
      const range2 = columnRanges[header2];

      // Union of the two column ranges
      const combinedRange = unifyRanges(range1, range2);

      namedExpressions.push({
        name: `${tableName}.${header1}.${header2}`,
        expression: `${convertToAbsolute(rangeIndexToLabel(combinedRange))}`,
      });
    });

    return namedExpressions;
  }

  async findAndShiftNamedRanges(text, direction, cellId, steps = 1) {
    const formula = this.rootState.cells.current.design.cellsMetaData[cellId]?.formula;
    // Check if decoding is necessary
    if (!needsDecoding(formula)) {
      return {
        absoluteNameRanges: [],
        updatedValues: [],
      };
    }
    const { decodedTitle, nameRanges } = decodeTableRefrencing(
      formula,
      cellId,
      this.rootGetters,
      this.rootState,
      TableHelper.inRowNameRangeFunction
    );
    let absoluteNameRanges = [];
    let updatedValues = [];
    const referenceCounts = {}; // Track the occurrence of each reference

    // Loop through each named range
    for (const namedRange of nameRanges) {
      const fullReference = namedRange.decoded;
      referenceCounts[fullReference] = (referenceCounts[fullReference] || 0) + 1;

      // Determine if the current instance should be absolute based on `absoluteRanges`
      const isAbsolute = absoluteNameRanges.some(
        (range) => range.reference === fullReference && range.index === referenceCounts[fullReference]
      );

      if (isAbsolute) {
        // Add to the absolute name ranges if marked as absolute
        absoluteNameRanges.push({
          reference: this.rootGetters["table/getDefaultNameRangeByLocal"](fullReference),
          index: referenceCounts[fullReference] - 1,
        });
      }

      // Handle relative named ranges for directional shifts
      if (namedRange.relativity === "relative") {
        const { defaultNameRange, localNameRange } = await this.findMatchingNamedRanges(
          namedRange.decoded,
          direction,
          steps
        );
        const originalDefaultNamedRange = this.rootGetters["table/getDefaultNameRangeByLocal"](namedRange.decoded);
        if (defaultNameRange) {
          updatedValues.push({
            updatedNameRange: defaultNameRange,
            updatedLocalNameRange: localNameRange,
            originalNameRange: originalDefaultNamedRange,
          });
        }
      } else {
        absoluteNameRanges.push({
          reference: this.rootGetters["table/getDefaultNameRangeByLocal"](fullReference),
          index: referenceCounts[fullReference] - 1,
        });
      }
    }

    return {
      absoluteNameRanges,
      updatedValues,
    };
  }

  async findMatchingNamedRanges(namedRange, direction, steps = 1) {
    namedRange = this.rootGetters["table/getDefaultNameRangeByLocal"](namedRange);
    const namedRangeValue = await this.rootGetters["table/getNamedExpression"](namedRange);
    if (!namedRangeValue) {
      return null; // No named range found
    }
    const sourceRange = rangeLabelToIndex(removePartUntilSymbol(namedRangeValue.expression, "!").replace(/\$/g, ""));
    const targetRange = updateRange(sourceRange, direction, steps);
    let matchedNamedRanges = await this.rootGetters["table/getNamedExpressionByRange"](rangeIndexToLabel(targetRange));
    //TODO: Add Error message when name range not found
    const localNameRange = this.rootGetters["table/getLocalNameRangeByDefault"](matchedNamedRanges?.name);
    return { defaultNameRange: matchedNamedRanges?.name, localNameRange: localNameRange };
  }

  async handleNameRanges(title) {
    const tableList = this.rootGetters["table/getAllTableNameRanges"]();
    let convertedList = [];
    tableList.forEach((tableName) => {
      const defaultName = this.rootGetters["table/getLocalNameRangeByDefault"](tableName.toLowerCase());
      convertedList.push(defaultName);
    });
    const allNamedExpression = this.rootState.table.namedExpressions;
    // convert name ranges to normal ranges
    const nameRanges = extractNamedRanges(title.toLowerCase(), convertedList);
    let textsList = {};
    nameRanges.forEach((element) => {
      // sync name rangs from local mapping
      const defaultNameRange = this.rootGetters["table/getDefaultNameRangeByLocal"](element.decoded);
      let newRange = "";
      if (element.type === "nameRange") {
        const expression = allNamedExpression.find(
          (e) => e.name.toLocaleLowerCase() === defaultNameRange.toLocaleLowerCase()
        );
        if (!expression) {
          return; // Exit the current iteration of the loop
        }
        const sheet = this.rootState.sheets.allSheets.find((item) => item?.id == expression?.sheetId);
        if (!sheet) {
          return; // Exit the current iteration of the loop
        }
        newRange = `${sheet.name}!${expression.expression}`;
      } else if (element.type === "inRowNameRange") {
        const convertedRange = TableHelper.inRowNameRangeFunction(
          element.decoded.toLowerCase(),
          this.rootState.cells.editCell.id,
          this.rootGetters,
          this.rootState
        );
        newRange = convertedRange;
        if (element.relativity === "absolute") {
          newRange = convertToAbsolute(newRange, { col: true });
        }
      }
      textsList[newRange.toUpperCase()] = element.original;
      title = title.toLowerCase().replace(element.original, newRange);
    });
    return { textsList, title };
  }
  findSelectedRange() {
    const cursorPosition = this.rootState.cells.editCell.cursorPosition;
    const extraFormats = ["A10:B30", "A10", "$A$10:$B$30", "$A$10", "$A10:$B30", "$A10", "A$10:B$30", "A$10"];
    const rangeText = getRefrenceAroundCursor(this.rootState.cells.editCell.text, cursorPosition - 1, extraFormats);
    const occurrence = findWordOccurrenceAtIndex(this.rootState.cells.editCell.text, rangeText, cursorPosition) ?? 1;
    let index = 1;
    const selectedRage = this.rootState.cells.formulaRanges.find((range) => {
      if (range.text.toLocaleLowerCase() === rangeText.toLocaleLowerCase()) {
        if (index === occurrence) {
          return true;
        } else {
          index++;
          return false;
        }
      } else {
        return false;
      }
    });
    return selectedRage;
  }
}
